<template>
    <div>
        <hts-form-select
            ref="select"
            v-model="cValue"
            v-model:text="cText"
            :items="selectItems"
            :label="$t('labels.groupName')"
            key-id="key"
            key-label="label"
            :prop="prop"
            :name="name"
            :filterable="true"
            :clearable="true"
            :creatable="creatable"
            :disabled="disabled"
            :param-prepare="selectItems"
            @change="handleChange"
            @create-new="createNew" />

        <hts-modal v-model="showAddNewName">
            <template #custom>
                <hts-card
                    :title="$t('labels.groupName')"
                    class="mt-5">
                    <hts-form-input v-model="newName" />
                </hts-card>
                <div class="flex mt-5 justify-end">
                    <hts-form-button
                        icon-name="hi-check-icon"
                        icon-position="right"
                        color="primary"
                        type="submit"
                        :loading="false"
                        :disabled="!newName"
                        @click="handleCreate">
                        {{ $t('labels.save') }}
                    </hts-form-button>

                    <hts-form-button
                        class="pl-2"
                        icon-name="hi-x-mark-icon"
                        icon-position="right"
                        color="error"
                        @click="showAddNewName = false">
                        {{ $t('labels.cancel') }}
                    </hts-form-button>
                </div>
            </template>
        </hts-modal>
    </div>
</template>
<script setup lang="ts">
const props = defineProps({
  modelValue: {
    type: [Array, String],
    default: () => ''
  },
  text: {
    type: String,
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  },
  creatable: {
    type: Boolean,
    default: true
  },
  prop: {
    type: String,
    default: ''
  },
  name: {
    type: String,
    default: ''
  },
  itemName: {
    type: String,
    default: ''
  }
})

const select = ref()
const newName = ref('')
const showAddNewName = ref(false as boolean)
const emits = defineEmits(['update:modelValue', 'update:text', 'click', 'change'])

const { modelValue, text, itemName } = toRefs(props)

const init = [
  {
    label: 'Điều độ',
    key: 'Điều độ'
  },
  {
    label: 'Kinh doanh',
    key: 'Kinh doanh'
  },
  {
    label: 'Tài xế',
    key: 'Tài xế'
  },
  {
    label: 'Pricing',
    key: 'Pricing'
  },
  {
    label: 'Chăm sóc khách hàng',
    key: 'Chăm sóc khách hàng'
  }
]

const selectItems = ref([...init])

const cValue = computed({
  get () {
    return modelValue.value
  },
  set (val: any) {
    emits('update:modelValue', val)
  }
})

const cText = computed({
  get () {
    return text.value || ''
  },
  set (val: any) {
    emits('update:text', val)
  }
})

const handleChange = (val: any) => {
  emits('change', val)
}

const createNew = (val: any) => {
  newName.value = ''
  showAddNewName.value = true

  select?.value?.hide()
}

onMounted(() => {
  handleCreate(itemName.value)
})

const handleCreate = (name?: string) => {
  if (name && typeof name === 'string') {
    newName.value = name
    selectItems.value = [...init]
  }

  if (!newName.value) {
    return
  }

  let checkExitItem = null as null | { [key: string]: string }
  const checkName = selectItems.value.map((item) => {
    if (item.label === newName.value) {
      checkExitItem = item
      return true
    }
    return false
  })

  if (checkName.includes(true) && checkExitItem) {
    cValue.value = checkExitItem.key
    cText.value = checkExitItem.label
    showAddNewName.value = false
    return
  }

  selectItems.value.push({
    key: newName.value,
    label: newName.value
  })

  if (!name) {
    cValue.value = newName.value
    cText.value = newName.value
  } else {
    cValue.value = newName.value
  }

  showAddNewName.value = false
  select.value.hide()
}

defineExpose({ handleCreate })
</script>
